export default __webpack_public_path__ + "static/media/featured.65cbb787.svg";